import { Message, Button, Icon, Table, Container, Modal } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef, useReducer } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { server, socket } from "../../../App";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { useSelector } from "react-redux";
import { paymentAt_Date_axios_func } from "../../Api/api";
import { useNavigate, useLocation } from "react-router-dom";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"


function PaymentAct(props) {
  const [time, setTime] = useState(false)
  const [state, dispatch] = useReducer(reducer, initialState);
  const [myLocation, setMylocation] = useState();
  const editorRef = useRef(null);
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const patientelleState = useSelector(selectPatientelleGrid);
  const location = useLocation();
  const {
    civilite,
    nom,
    prenom,
    commentaire_sur_patient,
    date_naissance,
    idpatient,

  } = patientelleState;

  sessionStorage.setItem("ID_Session", idpatient);

  useEffect(() => {
    setMylocation(location.pathname);
  }, [location]);

  if (time) {
    setTimeout(() => setTime(false), 3000);
  }

  // const { data, refetch } = useQuery("Get_Payment", () => {
  //   return payment_axios_func(fk_id_patient1 ? fk_id_patient1 : idpatient);
  // });
  let { data: data_At_date, refetch: refetch_At_date } = useQuery(
    "Get_Payment_at_Date",
    () => {
      let data = {
        id: idpatient,
        // id: fk_id_patient1 ? fk_id_patient1 : idpatient,
        date: moment().format("YYYY-MM-DD"),
      };
      // let data = {
      //   id: fk_id_patient1,
      //   // id: fk_id_patient1 ? fk_id_patient1 : idpatient,
      //   date: moment().format("YYYY-MM-DD"),
      // };
      return paymentAt_Date_axios_func(data);
    },
    {
      cacheTime: 1,
    }
  );

  const FactureFunc = () => {



    if (data_At_date === undefined) {
      data_At_date = []
    }
    let item = data_At_date[state.idx]



    let facture, titreDeLaFacture
    titreDeLaFacture = `<h3 style="text-align: center">NOTE D'HONORAIRES</h3> <h3 style="text-align: right">${item?.created_at.substring(0, 10)}</h3> <h3 style="text-align: left">${civilite} ${nom} ${prenom}</h3>`
    facture = ` <table
      style="
        border-collapse: collapse;
        width: 90%;
        background-color: rgb(255, 255, 255);
        border: 2px solid rgb(0, 0, 0);
        margin-left: auto;
        margin-right: auto;
      "
      border="1"
    >
      <colgroup>
        <col style="width: 50%;" />
        <col style="width: 50%;" />
      </colgroup>
      <tbody>
        <tr>
          <td
            style="
              border-width: 3px;
              border-color: rgb(0, 0, 0);
              text-align: center;
              background-color: rgb(236, 240, 241);
              border-style: solid;
            "
            scope="row"
          >
            <strong>INTITUL&Eacute;</strong>
          </td>
          <td
            style="
              border-width: 3px;
              border-color: rgb(0, 0, 0);
              text-align: center;
              background-color: rgb(236, 240, 241);
              border-style: solid;
            "
          >
            <strong>PRIX</strong>
          </td>
        </tr>
        <tr style="height: 100px;">
          <td
            style="
              border-width: 2px;
              border-color: rgb(0, 0, 0);
              text-align: center;
            "
          >
            ${item?.nom_acte}
          </td>
          <td
            style="
              border-width: 2px;
              border-color: rgb(0, 0, 0);
              text-align: center;
            "
          >
          ${item?.payment} DH
          </td>
        </tr>

        <tr>
          <td
            style="
              border-width: 2px;
              border-color: rgb(0, 0, 0);
              text-align: center;
            "
          >
            TOTAL
          </td>
          <td
            style="
              border-width: 2px;
              border-color: rgb(0, 0, 0);
              text-align: center;
            "
          >
          ${item?.payment} DH
          </td>
        </tr>
      </tbody>
    </table>
    <p style="text-align: right;">&nbsp;</p>
    <p style="text-align: right;"><strong>DR HANANE ANIBA</strong></p>
    <p style="text-align: center;"><strong>INPE : 09 103 254 0</strong></p>`
    let dataToSeeFinal = titreDeLaFacture + facture


    let Contents = (
      <div className='someSpace'>
        <Editor
          // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
          tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={dataToSeeFinal}
          init={{
            // selector: "textarea",
            branding: false,
            height: "81.5vh",
            menubar: false,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help ",
              "print",
            ],
            toolbar:
              "undo redo | formatselect | " +
              "bold italic underline print forecolor backcolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | ",
            content_style:
              "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm; } body{font-size:16px} ",
          }}
        />
      </div>
    );
    return Contents
  }

  useEffect(() => {
    function receivedMessage(m) {
      refetch_At_date();
    }

    socket.on("add", receivedMessage);
    socket.on("update", receivedMessage);
    socket.on("transfer", receivedMessage);
    return () => {
      socket.off("add", receivedMessage);
      socket.off("update", receivedMessage);
      socket.off("transfer", receivedMessage);
    };
    // eslint-disable-next-line
  }, []);

  const onSubmit = async (data) => {
    //
    axios({
      method: "put",
      responseType: "json",
      url: `${server}actes/updateActe`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        setTime(true)
        socket.emit("update", {
          civilite,
          nom,
          prenom,
          actionTypeSocket: "a été encaissé",
        });
        toast.success("Successfully created", {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // console.log({ date_naissance });

  // THIS IS TRUE DONT CHANGE THE DATE FORMAT
  let date_naissance_to_origin = moment(date_naissance).format("YYYY-DD-MM");
  let years = moment().diff(date_naissance_to_origin, "years", false);
  let months = moment().diff(date_naissance_to_origin, "months", false);
  let age;
  if (years === 0) {
    age = months;
  } else {
    age = years;
  }

  // console.log(data_At_date);
  return (
    <Container>
      {myLocation === "/Consultation" ? null : (
        <>
          <br></br>
          <h1>Vous pouvez encaisser une ou plusieurs prestations</h1>
          <h3>
            JE SUIS {civilite} {nom} {prenom} <br></br> Age : {age}
          </h3>
          <br></br>
        </>
      )}

      {commentaire_sur_patient ? (
        <Message color="red">
          <Message.Header>Important!</Message.Header>
          {commentaire_sur_patient}
        </Message>
      ) : null}
      {myLocation === "/Consultation" ? null : <br></br>}
      <Table
        // definition
        // celled
        // fixed
        // singleLine
        // striped
        // selectable
        // textAlign="center"
        definition
        celled
        fixed
        // singleLine
        striped
        selectable
        textAlign="center"
        size="small"
      // unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>date consultation</Table.HeaderCell>
            <Table.HeaderCell>Tarif normal</Table.HeaderCell>
            <Table.HeaderCell>Supplement</Table.HeaderCell>
            <Table.HeaderCell>Remise</Table.HeaderCell>
            <Table.HeaderCell>Paiement</Table.HeaderCell>
            <Table.HeaderCell>reste à payer</Table.HeaderCell>
            <Table.HeaderCell>créé le</Table.HeaderCell>
            <Table.HeaderCell>modifié le</Table.HeaderCell>
            <Table.HeaderCell>Facture</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data_At_date?.map((item, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{item.nom_acte}</Table.Cell>
              <Table.Cell>{item.created_at.substring(0, 10)}</Table.Cell>
              <Table.Cell>
                {item.prix_acte}
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_patient1}
                  {...register(`${idx}-fk_id_patient1`)}
                />

                <input
                  hidden={true}
                  defaultValue={
                    myLocation === "/Consultation"
                      ? moment().format("YYYY-MM-DD")
                      : item.date_consultation
                  }
                  // type="date"
                  // name="date_consultation"
                  // min="1900-01-01"
                  // max="3018-12-31"
                  {...register(`${idx}-date_consultation`)}
                ></input>
                <input
                  hidden={true}
                  maxLength={40}
                  type="number"
                  defaultValue={item.fk_id_acte}
                  {...register(`${idx}-fk_id_acte`)}
                />
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.suplement}
                      {...register(`${idx}-suplement`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.remise}
                      {...register(`${idx}-remise`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <div className=" field">
                  <div
                    className="ui input"
                    style={{
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <input
                      key={idx}
                      autoComplete="off"
                      style={{
                        textAlign: "center",
                        width: "100%",
                      }}
                      min="0"
                      max="100000"
                      maxLength={10}
                      type="number"
                      defaultValue={item.payment}
                      {...register(`${idx}-payment`)}
                    />
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell
                className={
                  item.prix_acte +
                    item.suplement -
                    item.remise -
                    item.payment ===
                    0
                    ? "paid"
                    : item.prix_acte +
                      item.suplement -
                      item.remise -
                      item.payment >
                      0
                      ? "unpaid"
                      : item.prix_acte +
                        item.suplement -
                        item.remise -
                        item.payment <
                        0
                        ? "overPaid"
                        : null
                }
              >
                {item.prix_acte +
                  item.suplement -
                  item.remise -
                  item.payment ===
                  0 ? (
                  <Icon name="checkmark" color="green" size="large" />
                ) : item.prix_acte +
                  item.suplement -
                  item.remise -
                  item.payment >
                  0 ? (
                  <Icon name="attention" color="red" size="large" />
                ) : item.prix_acte +
                  item.suplement -
                  item.remise -
                  item.payment <
                  0 ? (
                  <Icon name="close" color="black" size="large" />
                ) : null}
                {item.prix_acte + item.suplement - item.remise - item.payment}
              </Table.Cell>

              <Table.Cell>{item.created_at}</Table.Cell>
              <Table.Cell>{item.updated_at}</Table.Cell>
              <Table.Cell className="hovereffect">
                <Icon
                  key={idx}
                  circular
                  inverted
                  color="orange"
                  // floated="right"
                  onClick={() => dispatch({ type: ACTION.OPEN, size: "large", idx: idx })}
                  name="file"
                  size="large"
                // className="centerIcon_And_Float_RightMod"

                />

              </Table.Cell>
            </Table.Row>
          ))}


        </Table.Body>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan="9">
              {myLocation === "/Consultation" ? null : (
                <Button
                  floated="right"
                  color="violet"
                  onClick={() => navigate(-1)}
                >
                  Retour
                </Button>
              )}

              <Button
                // floated="right"
                disabled={time}
                animated
                positive
                onClick={handleSubmit(onSubmit)}
              >
                <Button.Content visible>Encaisser</Button.Content>
                <Button.Content hidden>
                  <Icon
                    name="dollar sign"
                    color="yellow"
                    className="IconFix"
                    size="big"
                  />
                </Button.Content>
              </Button>

            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {location.pathname === "/Consultation" ? "" : <SpeedDialComponent />}
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        {/* <Modal.Header className="center3columnheaders">Documents</Modal.Header> */}
        <Modal.Content>
          {FactureFunc()}
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
}

export default PaymentAct;
